export default __webpack_public_path__ + "static/media/left.2f8b0920.png";